<small class="debug">{{ me }}</small>
<div class="headButtons">
    <div fxLayout="row" fxLayoutAlign="space-around center">
        <a mat-icon-button
           class="mini-button"
           [cpPosition]="'bottom'"
           [cpPositionOffset]="'50%'"
           [cpOutputFormat]="'hex'"
           [cpPositionRelativeToArrow]="true"
           [(colorPicker)]="color"
           (colorPickerChange)="colorPickerChange($event)">
            <mat-icon class="addIcons">color_lens</mat-icon>
        </a>
        <a [matTooltip]="'Eye dropper from anywhere'" mat-icon-button (click)="eyeDropper()" class="mini-button">
            <mat-icon class="addIcons">colorize</mat-icon>
        </a>
<!--        <a [matTooltip]="'create a background'" mat-icon-button (click)="popupBackgroundWnd()" class="mini-button">-->
<!--            <mat-icon class="addIcons">add_photo_alternate</mat-icon>-->
<!--        </a>-->
        <a [matTooltip]="'generate AI background image'" mat-icon-button (click)="openAIBackgroundDialog()" class="mini-button">
            <mat-icon class="addIcons">auto_awesome</mat-icon>
        </a>
        <a [matTooltip]="'clear background'" mat-icon-button (click)="clearBackground()" class="mini-button">
            <mat-icon class="addIcons">delete</mat-icon>
        </a>
        <div class="hide-gt-sm">
            <app-scroll-buttons contentId="bgList"></app-scroll-buttons>
        </div>
        <app-video-link videoLink="backgroundsToolbox"></app-video-link>
    </div>
</div>

<div
    class="content-wrapper"
    id="bgList"
    infinite-scroll
    [scrollWindow]="false"
    [infiniteScrollDistance]="scrollDistance"
    [infiniteScrollThrottle]="throttle"
    (scrolled)="loadMoreSnippets()">

    <div cdkDropList
         cdkDropListSortingDisabled
         class="drag-panel dragCursor import-nav-bg"
         fxLayout="row wrap"
         fxLayoutAlign="center center"
         [cdkDropListData]="currentSnippets"
         (cdkDropListDropped)="dropImage($event)">

        @for (mini of currentSnippets; track mini) {
            <div cdkDrag class="thumbs" [cdkDragData]="mini">
                <mat-icon (click)="showInfoBg(mini)" class="thumbsHide fade-in-image">control_point</mat-icon>
                <img class="shadow-grow"
                     loading="lazy"
                     [src]="'./assets/bg_collection/' + mini['imageThumb']"
                     (click)="showInfoBg(mini)"
                >
                <div *cdkDragPreview class="drag-preview">
                    <img [src]="'./assets/bg_collection/' + mini['imageThumb']">
                </div>
            </div>
        }

        <div style="padding: 50px"></div>
    </div>
</div>

<ng-template let-modal #importPopup>
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        {{ 'general.importBackground' | transloco }}
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path
                    d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>
    <div mat-dialog-content>
        <br />
        <br />
        <div fxLayout="row wrap" fxLayoutAlign="center center" class="align-stretch">
            <mat-form-field class="info1">
                <mat-label>{{ 'general.name' | transloco }}</mat-label>
                <input matInput type="text" placeholder="" value="{{selectedImage.imageThumb | PipeTruncate:['35']}}"
                       readonly>
            </mat-form-field>
            <mat-form-field class="info2">
                <mat-label>{{ 'general.type' | transloco }}</mat-label>
                <input matInput type="text" placeholder="" value="{{selectedImage.ext}}" readonly>
            </mat-form-field>
            <mat-form-field class="info2">
                <mat-label>{{ 'general.width' | transloco }}</mat-label>
                <input matInput type="text" placeholder="" value="{{selectedImage.width}}" readonly>
            </mat-form-field>
            <mat-form-field class="info2">
                <mat-label>{{ 'general.height' | transloco }}</mat-label>
                <input matInput type="text" placeholder="" value="{{selectedImage.height}}" readonly>
            </mat-form-field>
        </div>
        <div class="image-wrapper">
            @if (imageLoading) {
                <div style="height: 300px; padding-top: 110px;">
                    <app-loading [type]="-1" [size]="'60px'"></app-loading>
                </div>
            }
            <div [hidden]="imageLoading">
                <img class="image-preview" (load)="onLoad($event)" width="100%" src="{{selectedImage.src}}" />
            </div>
            @if (imageImporting) {
                <div class="import-image">
                    <app-loading [type]="9" [size]="'60px'"></app-loading>
                </div>
            }
        </div>
        <br />
        <br />
        <div fxFlex fxLayoutAlign="center center" fxLayoutGap="32px">
            <button mat-raised-button color="warn" (click)="onImportClick()">
                <mat-icon>downloading</mat-icon>
                {{ 'general.import' | transloco }}
            </button>
            <button mat-raised-button color="primary" (click)="onClose()">{{ 'general.cancel' | transloco }}</button>
        </div>
    </div>
</ng-template>
